import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts } from "@ofqual/portal-core/core/types";
import { fromApiModel as reportConfigFromModel, ReportConfig } from "../domain/ReportConfig";
import { fromApiModel as embedConfigFromModel, EmbedConfig } from "../domain/EmbedConfig";

export class ReportsService extends BaseRemoteService {
  public async getReports(recognitionNumber: string | null, opts: Opts): Promise<ReportConfig[]> {
    const url = !!recognitionNumber
      ? `${this.apiRoot}/api/reports?recognitionNumber=${recognitionNumber}`
      : `${this.apiRoot}/api/reports`;

    const response = await super.getRequest<Model[]>(url, opts);

    return response.map(reportConfigFromModel);
  }

  public async getEmbedConfig(recognitionNumber: string, reportId: string, workspaceId: string, opts: Opts): Promise<EmbedConfig> {
    const url = `${this.apiRoot}/api/reports/embed?recognitionNumber=${recognitionNumber}&reportId=${reportId}&workspaceId=${workspaceId}`;
    const response = await super.getRequest<Model>(url, opts);

    return embedConfigFromModel(response);
  }
}